<div class="snack-bar">
    <div class="message-wrapper">
        <div class="icon">
            <span class="success-check-icon" aria-hidden="true"></span>
        </div>
        <div class="message">{{data.message || 'An unexpected error occurred'}}</div>
    </div>
    <button (click)="dismiss()">
        <img src="../../../../assets/images/cross_icon_grey.svg" alt="close" height="20px" width="20px">
    </button>
</div>
